import { render, staticRenderFns } from "./AccessWithRequest.vue?vue&type=template&id=7bbd73c4&scoped=true"
import script from "./AccessWithRequest.vue?vue&type=script&lang=js"
export * from "./AccessWithRequest.vue?vue&type=script&lang=js"
import style0 from "./AccessWithRequest.vue?vue&type=style&index=0&id=7bbd73c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd73c4",
  null
  
)

export default component.exports